import ShipmentSetup from './shipment-setup-container';

export default ShipmentSetup;